export const css = {
	root: 'uEXmIrSC',
	title: '_2c_VxaSC',
	wrapper: '_29TWSkm3',
	field: '_2wmDdx0b',
	bar: '_2yuqHrPq',
	assess: 'qVOVFX9l',
	barscore: '_3vI1moPV',
	assessScore: '_2av52mIO',
	' _key': 'prepost-viz/assess-viz'
};

export default css;
